import React, { Component } from 'react';
import { Modal, Spin, Icon, Button, Radio, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import Text from '../../../basicElement/Text';

const RadioGroup = Radio.Group;
const options = [
    { label: '是', value: '1' },
    { label: '否', value: '0' }
];

class SubmitRationalityApprove extends Component {
    state = {
        data: {},
        visible: false,
        loading: false,
    }

    show = () => {
        this.setState({
            data: {},
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleAdd = () => {
        const { data } = this.state;
        const carbonCopy = data.carbonCopy || (data.carbonCopy = []);
        carbonCopy.push({});
        this.setState({ data });
    }

    handleUserChange = (option, index) => {
        const { data } = this.state;
        const { carbonCopy } = data;
        const { value, text } = option;
        carbonCopy[index].userId = value;
        carbonCopy[index].userName = text;
        this.setState({ data });
    }

    handleRadioChange = () => {
        const { data } = this.state;
        data.isUrgent = e.target.value;
        this.setState({ data });
    }

    deleteUser = (index) => {
        const { data } = this.state;
        const { carbonCopy } = data;
        carbonCopy.splice(index, 1);
        this.setState({ data });
    }

    getContent = () => {
        const { data } = this.state;
        const { carbonCopy } = data;
        return (
            (carbonCopy || []).map((item, index, array) => {
                const { userId, userName } = item;
                const noUserId = array.map(item => item.userId).filter(i => !!i).join(',');
                return (
                    <div key={index} style={{marginTop: 12}}>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={userName}
                            params={{ limit: 20, noUserId }}
                            url={API_URL.contract.queryBaUserList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleUserChange(option, index)}
                        />
                        <Icon type="close-circle-o" style={{ marginLeft: 8, color: '#F00', cursor: 'pointer' }} onClick={() => this.deleteUser(index)} />
                    </div>
                );
            })
        );
    }

    submit = () => {
        const { data } = this.state;
        const { carbonCopy, isUrgent } = data;

        let index = -1;
        const params = {
            isUrgent
        };
        for (let { userId } of carbonCopy) {
            if (userId) {
                index++;
                params[`baHandOvers[${index}].handOverUserId`] = userId;
            }
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.handoverBaUserList, params).then(() => {
            message.success('批量交接成功');
            this.setState({
                loading: false,
            }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    render() {
        const { visible, loading, data } = this.state;
        const { isUrgent } = data;
        return (
            <Modal
                title="提交合理性审批"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                width="400px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: 0 }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">审批人:</div>
                                <div className="item-right">陶志红[200166]</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">抄送人:</div>
                                <div className="item-right">
                                    <Button type="primary" onClick={this.handleAdd}>添加抄送人</Button>
                                    { this.getContent() }
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left"><Text asterisk={true}>是否加急</Text></div>
                                <div className="item-right">
                                    <RadioGroup options={options} onChange={this.handleRadioChange} value={isUrgent} />
                                </div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default SubmitRationalityApprove;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/SubmitRationalityApprove.js